<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h38ArZ/tc-custom/9780231539364.jpg?1721429486399" alt="This image is the cover for the book Happiness and Goodness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happiness and Goodness
      </h1>
      <p class="bookDescription body article font2">
        <b>“A phenomenal book that offers innovative and penetrating insights into the most fundamental questions of human concern . . . vivid and enjoyable.”—Dov Weiss, University of Illinois at Urbana-Champaign</b><br/>  <br/> How should we evaluate the success of each person’s life? Countering the prevalent philosophical perspective on the subject, Steven M. Cahn and Christine Vitrano defend the view that our well-being is dependent not on particular activities, accomplishments, or awards but on finding personal satisfaction while treating others with due concern.<br/><br/> The authors suggest that moral behavior is not necessary for happiness and does not ensure it. Yet they also argue that morality and happiness are needed for living well, and together suffice to achieve that goal. Cahn and Vitrano link their position to elements within both the Hellenistic and Hebraic traditions, in particular the views of Epicurus and lessons found in the Book of Ecclesiastes. Written in an accessible style and illustrated with incisive vignettes drawn from history, literature, films, and everyday life, <i>Happiness and Goodness</i> is a compelling work of philosophy for anyone who seeks to understand the nature of a good life.<br/>  <br/> “Reminds me of a Socratic dialogue. The absence of jargon and use of realistic examples in this book make philosophy accessible to all interested in improving their lives.”—Andrea Tschemplik, American University<br/><br/> “This crisply written and incisive book draws on ancient thought and contemporary examples to develop a compelling account of living well.”—David Shatz, Yeshiva University<br/><br/> “I can’t remember the last time I read a book about ethics that was so fascinating.”—Ed Lake, deputy editor, <i>Aeon</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven M. Cahn, Christine Vitrano, Robert B. Talisse
      </h2>
      
      <p class="authorDescription body article">Steven M. Cahn is professor of philosophy at the Graduate Center of the City University of New York. He has written or edited some fifty books, including Fate, Logic, and Time; God, Reason, and Religion; Saints and Scamps: Ethics in Academia; and From Student to Scholar: A Candid Guide to Becoming a Professor.Christine Vitrano is associate professor of philosophy at Brooklyn College, City University of New York. She is the author of The Nature and Value of Happiness and coeditor, with Steven M. Cahn, of Happiness: Classic and Contemporary Readings in Philosophy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Columbia University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?991e42b2